import { useSplashScreen } from 'shared/layout/AppLayoutManager';

interface SplashScreenProps {
  isVisible?: boolean;
}

export function SplashScreen({ isVisible }: SplashScreenProps) {
  useSplashScreen(isVisible);

  return null;
}
